var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.170459 9.3804C0.10736 9.44305 0 9.39835 0 9.30943V6.09127C0 6.06463 0.0106336 6.03909 0.0295414 6.02031L6.06361 0.0290381C6.08234 0.0104382 6.10767 0 6.13407 0H9.37522C9.46448 0 9.50902 0.108069 9.44567 0.170962L0.170459 9.3804Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56139 11.971C5.54266 11.9896 5.51733 12 5.49093 12H2.24978C2.16052 12 2.11598 11.8919 2.17933 11.829L11.8295 2.24726C11.8926 2.18461 12 2.22931 12 2.31822V5.53638C12 5.56303 11.9894 5.58857 11.9705 5.60735L5.56139 11.971Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8295 10.1905C11.8926 10.1279 12 10.1726 12 10.2615V11.9C12 11.9552 11.9552 12 11.9 12H10.2498C10.1605 12 10.116 11.8919 10.1793 11.829L11.8295 10.1905Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37522 0C1.46448 0 1.50902 0.108069 1.44567 0.170962L0.170458 1.43713C0.10736 1.49978 0 1.45509 0 1.36617V0.1C0 0.0447715 0.0447715 0 0.1 0H1.37522Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlack);
export default __webpack_public_path__ + "static/media/icon--slack.0b56e02c0b973d6c2a8968c1af95453b.svg";
export { ForwardRef as ReactComponent };